import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/App.scss';

import { AuthProvider } from './contexts/AuthContext.js';
import NavBar from './components/NavBar.js';
import Home from './components/Home.js';
import Player from './components/Player.js';
import Games from './components/Games.js';
import Game from './components/Game.js';
import GameForm from './components/GameForm.js';
import Login from './components/Login.js';
import Account from './components/Account.js';
import Challenge from './components/Challenge.js';
import OnlineGames from './components/OnlineGames.js';
import OnlineGame from './components/OnlineGame.js';
import DevIndex from './components/DevIndex.js';
import DesignIndex from './components/DesignIndex.js';
import BoardPlayground from './components/BoardPlayground.js';
import PracticeGames from './components/PracticeGames.js';
import PracticeGame from './components/PracticeGame.js';
import GameReviewList from './components/GameReviewList.js';
import GameReviewDetail from './components/GameReviewDetail.js';
import NotFound from './components/NotFound.js';

function MainLayout() {
  return (
    <div className="App">
      <NavBar />

      <div className="App-content">
        <Outlet />
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Standalone full-viewport pages -- deliberately skip the normal
              NavBar/App-content layout (and its reserved header space). */}
          <Route exact path="/online/:gameId" element={<OnlineGame />} />
          <Route exact path="/dev/practice-game/:gameId" element={<PracticeGame />} />
          <Route exact path="/dev/game-review/:gameId" element={<GameReviewDetail />} />

          <Route element={<MainLayout />}>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/players/:playerId" element={<Player />} />
            <Route exact path="/games" element={<Games />} />
            <Route exact path="/games/new" element={<GameForm />} />
            <Route exact path="/games/:gameId" element={<Game />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/account" element={<Account />} />
            <Route exact path="/challenges/:challengeId" element={<Challenge />} />
            <Route exact path="/online" element={<OnlineGames />} />
            <Route exact path="/dev" element={<DevIndex />} />
            <Route exact path="/dev/design" element={<DesignIndex />} />
            <Route exact path="/dev/board-playground" element={<BoardPlayground />} />
            <Route exact path="/dev/practice-game" element={<PracticeGames />} />
            <Route exact path="/dev/game-review" element={<GameReviewList />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
